export default __webpack_public_path__ + "static/media/wxdclogo.69753f73.png";